import { Header } from '../../../../models';

const getPercentageFields = (headers: Header[]) =>
  headers.filter(({ format }) => format === 'percentage').map(({ field }) => field);

export default getPercentageFields;
